import { render, staticRenderFns } from "./DataRekening.vue?vue&type=template&id=2cf37544&"
import script from "./DataRekening.vue?vue&type=script&lang=js&"
export * from "./DataRekening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports